module.exports = function getResource(label, vars = []) {
    const resources = {
        review: 'Review',
        rateHeading: 'Rate this product',
        writeReview: 'Write your review',
        rateAndReview: 'Rate & Review',
        headline: 'Headline',
        optional: 'optional',
        addAHeadline: 'Add a headline',
        maxChar: `Max. ${vars[0]} characters`,
        seeFull: 'See full',
        addPhoto: 'Add photo',
        upToTwoImages: 'up to two images',
        wouldYouRecommendThisProduct: 'Would you recommend this product?',
        yes: 'Yes',
        no: 'No',
        productAsAfreeSample: 'I received this product as a free sample',
        sephoraEmployee: 'I am a Sephora employee',
        next: 'Next',
        errorMessageText: `Review must be at least ${vars[0]} characters`,
        errorMessageRating: 'Please select a star rating',
        errorMessageTextRecommend: 'Please select one'
    };
    return resources[label];
};
